export const routes = [
    /* user 관련 */
    { path: 'login', accessLevel: 'public' },
    { path: 'regist', accessLevel: 'public' },
    { path: 'init' },
    { path: 'find/id', accessLevel: 'public' },
    { path: 'find/password', accessLevel: 'public' },
    { path: 'user/list'},
    { path: 'user/detail'},
    { path: 'intro/company', accessLevel: 'public' },
    { path: 'intro/service', accessLevel: 'public' },
    { path: 'intro/policy', accessLevel: 'public' },

    /* prop 관련 */
    { path: 'invest/list' },
    { path: 'invest/detail' },
    { path: 'loan/application' },
    { path: 'building/content' },
    { path: 'building/review', accessLevel: 'public' },
    { path: 'receipt/list'},
    { path: 'receipt/detail'},
    { path: 'invest/write/overview'},
    { path: 'invest/write/collateral'},
    { path: 'invest/write/borrower'},
    { path: 'invest/write/advice'},
    { path: 'credit/proposal'},
    { path: 'credit/proposal', dynamicPath: 'credit/proposal/:propertyId/:userTel'},
    { path: 'credit/direct/proposal'},
    { path: 'credit/direct/list'},
    { path: 'lender/list'},
    { path: 'lender/detail'},
    { path: 'lender/save'},
    { path: 'appraisal/list'},
    { path: 'appraisal/detail'},

    /* 마케팅 관련 */
    { path: 'review/loanSim', accessLevel: 'public' },
    { path: 'review/sim/start', accessLevel: 'public' },
    { path: 'review/sim/input', accessLevel: 'public' },
    { path: 'review/sim/searchResult', accessLevel: 'public' },
    { path: 'review/sim/complete', accessLevel: 'public' },
    { path: 'review/accepts', accessLevel: 'public' },
    { path: 'review/appraisal', accessLevel: 'public' },
    /* 개발 */
    { path: 'dev/component' },
    { path: 'dev/table' },
]
